import * as types from './mutation-types'

export default {
    [types.SET_BUNDLES](state, bundles) {
        state.bundles = bundles
    },

    [types.ADD_BUNDLE](state, bundle) {
        state.bundles.push(bundle)
    },

    [types.UPDATE_BUNDLE](state, updated) {
        const index = state.bundles.findIndex(b => b.id === updated.id)
        if (index !== -1) state.bundles.splice(index, 1, updated)
    },

    [types.DELETE_BUNDLE](state, id) {
        state.bundles = state.bundles.filter(b => b.id !== id)
    },

    [types.SET_IMAGE](state, { id, image }) {
        state.bundles = state.bundles.map((bundle) => { if (bundle.id === id) { bundle.image = image } return bundle })
    },

    [types.SET_SHOP_BUNDLES](state, shopBundles) {
        state.shopBundles = shopBundles
    },

    [types.ADD_SHOP_BUNDLE](state, shopBundle) {
        state.shopBundles.push(shopBundle)
    },

    [types.UPDATE_SHOP_BUNDLE](state, updated) {
        const index = state.shopBundles.findIndex(sb => sb.id === updated.id)
        if (index !== -1) state.shopBundles.splice(index, 1, updated)
    },

    [types.DELETE_SHOP_BUNDLE](state, id) {
        state.shopBundles = state.shopBundles.filter(sb => sb.id !== id)
    },
}
